import { WintSuperkollAPIModelAnnualAccounts } from "wint-api-client/dist/types";

export type AuditorCasePanelState = { kind: "hidden" } | { kind: "noCase" } | { kind: "case"; caseId: number };

// The API also returns no case to a viewer who isn't on it, so "no case yet" is only
// certain before the report has been sent to the auditor.
export function getAuditorCasePanelState(
  isAuditorCommunicationEnabled: boolean,
  isRevisor: boolean,
  annualReport: Pick<WintSuperkollAPIModelAnnualAccounts.AnnualReport, "auditorCase" | "auditorState"> | undefined
): AuditorCasePanelState {
  if (!isAuditorCommunicationEnabled || !annualReport) return { kind: "hidden" };
  if (annualReport.auditorCase) return { kind: "case", caseId: annualReport.auditorCase.id };
  const notSentToAuditor =
    annualReport.auditorState ===
    WintSuperkollAPIModelAnnualAccounts.SuperkollAuditorAnnualReportState.AuditorNotStarted;
  return isRevisor && notSentToAuditor ? { kind: "noCase" } : { kind: "hidden" };
}
